// CIN-6879: ONE address formatter for the whole widget.
//
// Reserve with Google requires the store's address above the fold on every
// landing page. Before this ticket the only address rendering lived inside
// LocationSelection's step-1 list, so any RwG landing URL (which always pins a
// location and therefore skips step 1) never showed an address at all.
//
// formatAddressLines is moved verbatim from LocationSelection.js so the modal
// header and the location list can never drift apart. The single behavior
// change: a null/undefined location returns [] (it used to return '') so every
// caller can unconditionally .map over the result.

export const formatAddressLines = (location) => {
  if (!location) return [];
  const addressLines = [];

  // First line: address1
  if (location.address1) {
    addressLines.push(location.address1);
  }

  // Second line: address2 (if exists)
  if (location.address2) {
    addressLines.push(location.address2);
  }

  // Third line: city, state zip
  const cityStateZip = [];
  if (location.city) cityStateZip.push(location.city);
  if (location.state) cityStateZip.push(location.state);
  if (location.zip_code) cityStateZip.push(location.zip_code);

  if (cityStateZip.length > 0) {
    // Format as "City, State Zip"
    let formattedLine = '';
    if (location.city && location.state) {
      formattedLine = `${location.city}, ${location.state}`;
      if (location.zip_code) {
        formattedLine += ` ${location.zip_code}`;
      }
    } else {
      formattedLine = cityStateZip.join(' ');
    }
    addressLines.push(formattedLine);
  }

  return addressLines;
};

// Single-line form for the modal header, where the address sits directly under
// the merchant name in a centered, space-constrained slot. Empty string when
// the location carries no address fields at all, so the caller can skip the
// node entirely rather than render a blank line.
export const formatAddressSingleLine = (location) =>
  formatAddressLines(location).join(', ');
